// src/BeforeOBT.js
import React, { useEffect, useMemo, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';
import api from './api.js';
import './BeforeOBT.css';
import { copyToClipboard, shareContent } from './util.js';

const BeforeOBT = () => {
  const [myId, setMyID] = useState('');
  const [phone, setPhone] = useState('');
  const [friendId, setFriendId] = useState('');
  const [isFinish, setIsFinish] = useState(false);
  const RELEASE_DATE = new Date(2025, 7, 1, 0, 0, 0).getTime();
  const [isExpired, setIsExpired] = useState(Date.now() >= RELEASE_DATE);

  useEffect(()=>{
    window.setPerm = function (locationPerm, notificationPerm) {
      return;
    };

    window.setDevicePosition = function (lat, long) {
      return;
    };

    window.setAppSetting = function (safeAreaHeight, platform, fcmToken, locationPerm, notificationPerm) {
      return;
    };

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('CustomChannel', 'REACT_RENDERED');
    }
  },[]);

  function goInstagram() {
    window.open("https://instagram.com/hotple_kr", '_blank');
  }

  async function whenRegistrationButtonClicked() {
    if(!myId || myId.trim() === ''){
      alert('본인의 인스타 ID를 입력해주세요!\n(공식 인스타 팔로우 필수!)');
      return;
    }

    if(!phone || phone.trim() === ''){
      alert('OBT 안내 및 경품 발송을 위해 휴대폰 번호를 입력해주세요!');
      return;
    }

    try {
      // 1) UTM 파라미터 키 목록
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
      const params = new URLSearchParams(window.location.search);

      // 2) URL → localStorage → null 순으로 안전하게 읽기
      let utm_source, utm_medium, utm_campaign, utm_content;
      try {
        utm_source   = params.get('utm_source')   ?? localStorage.getItem('utm_source')   ?? null;
        utm_medium   = params.get('utm_medium')   ?? localStorage.getItem('utm_medium')   ?? null;
        utm_campaign = params.get('utm_campaign') ?? localStorage.getItem('utm_campaign') ?? null;
        utm_content  = params.get('utm_content')  ?? localStorage.getItem('utm_content')  ?? null;
      } catch (e) {
        // localStorage 접근 에러 등 안전 처리
        console.warn('UTM 읽기 중 에러 발생:', e);
        utm_source = utm_medium = utm_campaign = utm_content = null;
      }

      // 3) API 호출 (UTM 필드 개별 전송)
      await api.post('/register-obt', {
        instagram_id: myId.trim().replace(/^@/, ''),
        phone       : phone.trim().replace(/-/g, ''),
        inviter_id  : friendId.trim().replace(/^@/, '') || null,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
      });

      // 4) 성공 플래그
      setIsFinish(true);

      // 5) Pixel 트래킹 여부 판단
      const hasUtmInURL     = utmKeys.some(key => params.get(key));
      const hasUtmInStorage = utmKeys.some(key => localStorage.getItem(key));
      const isFromAnyUtmAd  = hasUtmInURL || hasUtmInStorage;

      if (isFromAnyUtmAd) {
        ReactPixel.track('CompleteRegistration', {
          content_name: 'Hotple 사전예약',
          utm_source:   utm_source,
          utm_medium:   utm_medium,
          utm_campaign: utm_campaign,
          utm_content:  utm_content,
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        alert('이미 사전예약을 완료했습니다☺️\n\n친구에게도 사전예약 추천하고 당첨 확률을 더 높여볼까요?');
        setIsFinish(true);
      } else {
        alert('사전예약 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      }
    }
  }

  async function whenInviteButtonClicked() {
    const text = `[HOTPLE 초대]\n@${myId.trim().replace(/^@/, '')} 님이 당신을 HOTPLE로 초대했어요💌 인스타 핫플 찾을 땐, HOTPLE!\nhttps://app.hotple.today`
    await copyToClipboard(text);
    alert('사전예약 URL이 클립보드에 복사되었어요!\n이제 친구에게 전달해볼까요?');
  }

  const ReleaseCountdown = () => {
    const [msLeft, setMsLeft] = useState(RELEASE_DATE - Date.now());

    useEffect(() => {
      const id = setInterval(() => {
        const diff = RELEASE_DATE - Date.now();
        setMsLeft(diff > 0 ? diff : 0);
      }, 100);
      return () => clearInterval(id);
    }, []);

    // 분해
    const days    = Math.floor(msLeft / 86400000);
    const hours   = Math.floor((msLeft % 86400000) / 3600000);
    const minutes = Math.floor((msLeft % 3600000)  / 60000);
    const seconds = Math.floor((msLeft % 60000)    / 1000);
    const dec     = Math.floor((msLeft % 1000) / 100);

    // 포맷 함수
    const pad = (num) => String(num).padStart(2, '0');
    const formatted =  
      `D-${days} ` +
      `${pad(hours)}:` +
      `${pad(minutes)}:` +
      `${pad(seconds)}.${dec}`;

    return (
      <div className='countdownFrame'>
        <div className='countdown1'>사전예약 이벤트 진행 중!</div>
        <div className='countdown2'>{formatted}</div>
      </div>
    );
  };

  useEffect(() => {
    if (isExpired) return;         // 이미 만료된 상태면 더 이상 체크 안 함
    const timer = setInterval(() => {
      if (Date.now() >= RELEASE_DATE) {
        setIsExpired(true);
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [isExpired]);

  return (
  <div className="before-obt-container">
    <div className="before-obt-card">
      <div className="title">
        <span className="hotple-logo">HOTPLE</span> 의<br/>오픈 베타 테스트(OBT)가<br/>08/01(금) 부터 진행됩니다!
      </div>
      {!isExpired &&
        <div className="info2">
          <ReleaseCountdown />
        </div>
      }
      {!isExpired &&
        <div style={{position: 'relative'}}>
          <div className='eventbadge'>당첨 확률 높아요!</div>
          <video
              className="video"
              alt="OBT 사전예약 포스터"
              autoPlay
              loop
              muted
              playsInline
              src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/obt_pre_event.mp4"
          />
        </div>
      }
      {isExpired ? (
        <div className='formFrame'>
          <div className="info2">
            <div className="title">⏰ 서비스 오픈 대기 중 ⏰</div>
            <br/>
            <div className="p">서비스가 오픈 되는 대로</div>
            <div className="p">사전예약자 분들께 알림을 보내드려요 :)</div>
          </div>
        </div>
      ) : !isFinish ? (
        <div className='formFrame'>
          <div className="idbox">
            <div className='label'>1. 공식 인스타 팔로우 (필수) →</div>
            <div className='label2' onClick={() => goInstagram()}>
              @hotple_kr [클릭]
            </div>
          </div>

          <div className="idbox2">
            <div className='label'>2. 인스타 ID</div>
            <input
              type="text"
              id="idInput"
              className="idinput"
              placeholder="예시) @initial_c564"
              value={myId}
              onChange={(e) => setMyID(e.target.value)}
            />
          </div>

          <div className="idbox2">
            <div className='label'>3. 연락처</div>
            <div className='label3'>*앱 출시 알림 & 경품 발송을 위해서만 1회성 활용</div>
            <input
              type="text"
              id="idInput"
              className="idinput"
              placeholder="010-1234-5678"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <details className="idbox2">
            <summary className="label4">
              추천인 인스타 ID (선택)
            </summary>
            <div className="idbox3">
              <div className="label3">
                *추천해준 친구도, 나도 둘 다 경품 당첨 확률 2배 UP!
              </div>
              <input
                type="text"
                id="friendInput"
                className="idinput"
                placeholder="추천인이 있을 시 입력"
                value={friendId}
                onChange={(e) => setFriendId(e.target.value)}
              />
            </div>
          </details>
        </div>
      ) : (
        <div className='formFrame'>
          <div className="info2">
            <div className="title">🎉 사전예약 이벤트 참여 완료 🎉</div>
            <br/>
            <div className="p">사전예약 이벤트에 성공적으로 참여했어요!</div>
            <div className="p">추후, OBT 시작 및 당첨 결과를 안내 드리겠습니다☺️</div>
          </div>
        </div>
      )}


      {!isExpired?
        !isFinish ?
          <div className='loginbutton' onClick={()=>whenRegistrationButtonClicked()}>
            <div className='text'>사전예약 완료!</div>
          </div>
          :
          <div className='loginbutton2' onClick={()=>whenInviteButtonClicked()}>
            <div className='text'>친구에게 사전예약 링크 보내기!<br/>(당첨 확률 2배 UP!)</div>
          </div>
        :
          <div className='loginbutton' onClick={() => goInstagram()}>
            <div className='text'>HOTPLE 공식 인스타 →</div>
          </div>
      }

      <div className="info">
        <div className='p2'>* 사전예약 기간: ~ 07월 31일(목)</div>
        <div className='p2'>* OBT 시작일: 8월 1일(금)</div>
        <div className='p2'>* 당첨자 결과 발표: 8월 8일(금)</div>
        <div className='p2'>* 총 100인 추첨! 당첨 시 종류 선택가능!</div>
      </div>
    </div>
  </div>
)};

export default BeforeOBT;
